import axios from 'axios';
import { errorHandler } from "../utils/utils";
import {
  setStudentByBatchCourseId, getAllStudents, setStudentDetails, setStudentProfileDetails, getCountriesList, getStateList, getTermGoals, getClassList, getCityList, getCurrentAddressCityList, setStudentCoursesDetails, getAcedemicYearList, setAllIdCardsLoading, setAllIdCardsSuccess, setAllIdCardsError,
  setHeadOfcRegistraionListLoading, setHeadOfcRegistraionListSuccess, setHeadOfcRegistraionListError
} from '../redux/reducer/studentReducer';
import { loginClear } from '../redux/reducer/authReducer';

const COURSE_SERVICE = process.env.REACT_APP_COURSE_SERVICE;
const STUDENT_LOGIN_SERVICE = process.env.REACT_APP_STUDENT_LOGIN_SERVICE
const LOGIN_SERVICE = process.env.REACT_APP_LOGIN_SERVICE
const STUDENT_SERVICE = process.env.REACT_APP_STUDENT_SERVICE
const ADMIN_SERVICE = process.env.REACT_APP_ADMIN_SERVICE;
const SCHEDULER_SERVICE = process.env.REACT_APP_SCHEDULER_SERVICE;

export const getStudentPasswordsApi = async ({ token }) => {
  try {
    const res = await axios.get(`${LOGIN_SERVICE}/MasterPassword/GetStudentMasterPassword`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data
  } catch (err) {
    return err;
  }
}
export const sendStudentPasswordOtpApi = async ({ data, token }) => {
  try {
    const res = await axios.post(`${LOGIN_SERVICE}/MasterPassword/SendMasterPasswordOtp`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data
  } catch (err) {
    return err;
  }
}
export const editStudentPasswordsApi = async ({ data, token }) => {
  try {
    const res = await axios.post(`${LOGIN_SERVICE}/MasterPassword/UpdateMasterPassword`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data
  } catch (err) {
    return err;
  }
}

export const getMasterPasswordsApi = async ({ token }) => {
  try {
    const res = await axios.get(`${LOGIN_SERVICE}/MasterPassword/GetMasterPasswords`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data
  } catch (err) {
    return err;
  }
}
export const editMasterPasswordsApi = async ({ data, token }) => {
  try {
    const res = await axios.post(`${LOGIN_SERVICE}/MasterPassword/Edit`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data
  } catch (err) {
    return err;
  }
}
export const getAllStudentsApi = async ({ token, data, dispatch }) => {
  const res = await axios.post(`${COURSE_SERVICE}/Student/GetAll`, data, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
  dispatch(getAllStudents(res.data?.data))
}

export const addCourseApi = async ({ data, token }) => {
  const res = await axios.post(`${COURSE_SERVICE}/Student/AddCourse`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return res;
}

export const getStudentDetailsApi = async ({ studentId, token, dispatch }) => {
  const res = await axios.get(
    `${STUDENT_SERVICE}/User/GetProfile/${studentId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  dispatch(setStudentDetails(res.data))
}

export const getStudentsCoursesApi = async ({ studentId, token, dispatch }) => {
  const res = await axios.get(
    `${STUDENT_SERVICE}/EnrolledCourse/StudentCourse/${studentId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  dispatch(setStudentCoursesDetails(res.data))
}

export const studentPasswordChangeApi = async ({ studentId, token }) => {
  try {
    const res = await axios.post(
      `${STUDENT_SERVICE}/User/ChangePassword`, null,
      {
        params: { studentId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    return res;
  } catch (err) {
    errorHandler(err, studentId, `${COURSE_SERVICE}/Student/ChangePassword`)
    return err;
  }
}

export const getStudentLoginDetail = async ({ token }) => {
  const res = await axios.get(`${STUDENT_SERVICE}/User/SendLoginDetailSms`, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  })
  return res;
}

export const studentDeleteCourseApi = async (payload, token) => {
  try {
    const res = await axios.post(
      `${STUDENT_SERVICE}/EnrolledCourse/DeleteStudentCourse`, payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    )
    return res;
  } catch (err) {
    errorHandler(err, payload, `${STUDENT_SERVICE}/EnrolledCourse/DeleteStudentCourse`)
    return err;
  }
}



export const getStudentGetProfileApi = async ({ studentId, token, dispatch }) => {
  const res = await axios.get(
    `${STUDENT_SERVICE}/User/GetProfile/${studentId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  dispatch(setStudentProfileDetails(res.data))
}
export const getStudentsListApi = async ({ data, token }) => {
  const res = await axios.post(
    `${STUDENT_SERVICE}/User/GetAll`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return res.data;
}
export const getIncompleteStudentsListApi = async ({ data, token }) => {
  const res = await axios.post(
    `${STUDENT_SERVICE}/IncompleteRegistration/GetAll`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return res.data;
}
export const downloadStudentSampleFileApi = async ({ key, token }) => {
  const res = await axios.get(
    `${SCHEDULER_SERVICE}/Upload/DownloadSampleFile?key=${key}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return res.data;
}

export const updateStudentProfileApi = async ({ studentId, token, dispatch, data }) => {
  try {
    const res = await axios.post(
      `${STUDENT_SERVICE}/User/${!studentId ? "CreateProfile" : "EditProfile"}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch(setStudentProfileDetails(res.data))
    return res.data;

  } catch (err) {
    errorHandler(err, data, `${STUDENT_SERVICE}/User/${!studentId ? "CreateProfile" : "EditProfile"}`)
    return err;
  }
}


export const fetchCountries = async ({ dispatch }) => {
  const res = await axios.get(
    `${STUDENT_LOGIN_SERVICE}/GetCountryList`,
  )
  dispatch(getCountriesList(res.data))
}

export const fetchClasses = async ({ dispatch }) => {
  const res = await axios.post(
    `${LOGIN_SERVICE}/GetCurrentClasses`,
  )
  dispatch(getClassList(res.data))
}
export const fetchGoals = async ({ dispatch }) => {
  const res = await axios.get(
    `${LOGIN_SERVICE}/GetGoal`,
  )
  dispatch(getTermGoals(res.data))
  return res?.data
}

export const fetchState = async ({ dispatch }) => {
  const res = await axios.get(
    `${LOGIN_SERVICE}/GetStateList`,
  )
  dispatch(getStateList(res.data))
}
export const fetchCities = async ({ dispatch, payload, token }) => {
  const res = await axios.post(
    `${LOGIN_SERVICE}/GetCities`, payload
  )
  dispatch(getCityList(res.data))
  return res?.data
}
export const fetchAcedemicYears = async ({ dispatch, token }) => {
  try {
    const res = await axios.get(`${COURSE_SERVICE}/AcademicYear/GetAll`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    if (res?.data?.statusCode === 401) {
      localStorage.removeItem("auth-user");
      dispatch(loginClear());
    }
    dispatch(getAcedemicYearList(res.data))
    return res?.data
  } catch (err) {
    if (err?.response?.data?.statusCode === 401) {
      localStorage.removeItem("auth-user");
      dispatch(loginClear());
      window.open('/', '_self');
    }
    // errorHandler(err, data, `${STUDENT_SERVICE}/EnrolledCourse/EnrolledStudentExport`)
    return err;
  }
}
export const fetchCurrentAddressCities = async ({ dispatch, payload, token }) => {
  const res = await axios.post(
    `${LOGIN_SERVICE}/GetCities`, payload
  )
  dispatch(getCurrentAddressCityList(res.data))
}

export const getGoals = async ({ dispatch }) => {
  const res = await axios.get(
    `${STUDENT_LOGIN_SERVICE}/GetGoal`,
  )
  dispatch(getTermGoals(res.data))
}

export const getFilterGoals = async (payload, token) => {
  const res = await axios.post(
    `${COURSE_SERVICE}/Goal/GetFilterGoals`, payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  )
  return res.data;
}


export const getStudentsByCourseBatchId = async ({ data, token, dispatch }) => {
  const res = await axios.post(
    `${STUDENT_SERVICE}/User/GetStudents`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  dispatch(setStudentByBatchCourseId(res.data))
  return res?.data
}

export const downloadStudentListApi = async ({ token, data }) => {
  try {
    const res = await axios.post(`${STUDENT_SERVICE}/User/ExportStudent`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return res.data;
  } catch (err) {
    errorHandler(err, data, `${STUDENT_SERVICE}/User/ExportStudent`)
    return err;
  }
}
export const downloadCourseStudentListApi = async ({ token, data }) => {
  try {
    const res = await axios.post(`${STUDENT_SERVICE}/EnrolledCourse/EnrolledStudentExport`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return res.data;
  } catch (err) {
    errorHandler(err, data, `${STUDENT_SERVICE}/EnrolledCourse/EnrolledStudentExport`)
    return err;
  }
}
export const updateTokenApi = async ({ token, data }) => {
  try {
    const res = await axios.post(`${LOGIN_SERVICE}/Admin/UpdateCityToken`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return res.data;
  } catch (err) {
    errorHandler(err, data, `${LOGIN_SERVICE}/Admin/UpdateCityToken`)
    return err;
  }
}


export const getExtendsStudentsListApi = async ({ data, token }) => {
  const res = await axios.post(
    `${STUDENT_SERVICE}/LoginExtend/GetExtends`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return res.data;
}

export const getExtandDetails = async ({ id, token, dispatch }) => {
  const res = await axios.post(`${STUDENT_SERVICE}/LoginExtend/GetExtend/${id}`, {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return res?.data
}

export const createLoginExtendApi = async ({ token, data }) => {
  try {
    const res = await axios.post(`${STUDENT_SERVICE}/LoginExtend/${data?.id ? 'Edit' : 'Create'}`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return res.data;
  } catch (err) {
    return err;
  }
}

export const deleteExtendApi = async ({ id, token }) => {
  const res = await axios.post(
    `${STUDENT_SERVICE}/LoginExtend/DeleteLoginExtend/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return res.data;
}

export const getAllIdCardsApi = async ({ token, dispatch, data }) => {
  dispatch(setAllIdCardsLoading());
  try {
    const res = await axios.post(`${STUDENT_SERVICE}/IdCard/IdCardProfiles`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    dispatch(setAllIdCardsSuccess(res.data));
  } catch (err) {
    dispatch(setAllIdCardsError(err));
  }
}

export const fetchIdCardProfileDataApi = async ({ token, dispatch, id }) => {
  try {
    const res = await axios.get(`${STUDENT_SERVICE}/IdCard/IdCardProfile/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data;
  } catch (err) {
    return err;
  }
}
export const updateCardProfileStatusApi = async ({ token, dispatch, data }) => {
  try {
    const res = await axios.post(`${STUDENT_SERVICE}/IdCard/UpdateStatus`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data;
  } catch (err) {
    return err;
  }
}

export const getStudentIDProfileExport = async ({ token, dispatch, data }) => {
  try {
    const res = await axios.post(`${STUDENT_SERVICE}/IdCard/ExportStudentProfile`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data
  } catch (err) {
    errorHandler(err, data, `${STUDENT_SERVICE}/IdCard/ExportStudentProfile`)
    return err
  }
}

export const downloadIDCardStatusApi = async ({ taskId, token }) => {
  try {
    const res = await axios.get(`${STUDENT_SERVICE}/IdCard/GetZipProgress/${taskId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
    )
    return res.data;
  } catch (err) {
    errorHandler(err, taskId, `${STUDENT_SERVICE}/IdCard/GetZipProgress/${taskId}`)
    return err;
  }
}
export const getDownloadIdCardApi = async ({ taskId, token }) => {
  try {
    const res = await axios.get(`${STUDENT_SERVICE}/IdCard/DownloadZip/${taskId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
    )
    return res.data;
  } catch (err) {
    errorHandler(err, taskId, `${STUDENT_SERVICE}/IdCard/DownloadZip/${taskId}`)
    return err;
  }
}

export const getHeadOfcRegistraionApi = async ({ token, data, dispatch }) => {
  dispatch(setHeadOfcRegistraionListLoading())
  try {
    const res = await axios.post(`${SCHEDULER_SERVICE}/FeeRegistrationHeadOfficeApi/GetLogs`, data, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    });
    dispatch(setHeadOfcRegistraionListSuccess(res.data))
  } catch (err) {
    dispatch(setHeadOfcRegistraionListError(err))
  }
}